// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from './base-entity';
import { Brand } from './brand';
import { Equipment } from './equipment';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class EquipmentModel extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  equipmentModelId: number;
  brandId: number;
  modelName: string;
  brand: Brand;
  equipments: Equipment[];
}

